import React, { useEffect, useContext } from 'react';
import { Context } from '../store/reducer';
import * as $ from 'jquery';

const VectorGridSlider = () => {
    const { state, dispatch } = useContext(Context);
    
    useEffect(()=>{
        $(".mesh-depth-btn").click(function () {
            $(this).toggleClass('is-active');
            $("#mesh-depth").toggleClass('is-active');
        });
    },[]);

    return <div class="mesh-depth" id="mesh-depth">
                <div class="mesh-depth-btn" title="データ濃度">
                    <span class="h-mesh-icon"></span>
                </div>
                <div class="mesh-depth-inner">
                    <input type="range" class="input-range" value={state.opacity} min="0" max="1" step="0.1"
                        onChange={(e)=>{dispatch({
                                type: 'SET_OPACITY',
                                payload: e.target.value})}} />
                </div>
            </div>

}

export default VectorGridSlider